import { Logo } from '@/components/Logo';
import Footer from '@/renderer/Footer';
import { isIosNative } from '@/renderer/utils/isIosNative';

export default LinksPage;

const LINKS = [
  {
    href: '/order/nfl',
    text: 'Order NFL Service',
    target: '_self',
  },
  {
    href: '/archive',
    text: 'Our Results',
    target: '_self',
  },
  {
    href: 'https://www.betstamp.app/u/ras',
    text: 'betstamp tracking',
    target: '_blank',
  },
  {
    href: 'http://www.footballbettors.com',
    text: 'Football Bettors - NFL Newsletter',
    target: '_blank',
  },
  {
    href: 'https://www.bettingtalk.com',
    text: 'Betting Talk',
    target: '_blank',
  },
  {
    href: 'http://www.tiktok.com/@raspicks',
    text: 'RAS TikTok',
    target: '_blank',
  },
  {
    href: 'https://www.youtube.com/@raspicks?sub_confirmation=1',
    text: 'RAS YouTube',
    target: '_blank',
  },
  {
    href: 'http://www.x.com/raspicks',
    text: 'RAS Twitter',
    target: '_blank',
  },
  {
    href: 'https://raspicks.substack.com/',
    text: 'RAS Substack',
    target: '_blank',
  },
];

export function Links() {
  return (
    <div className="flex h-40 min-h-[stretch] flex-1 grow flex-col justify-between overflow-hidden">
      <div className="overflow-auto pt-12">
        <div className="relative px-4 sm:mt-0 sm:px-6 lg:px-8">
          <div className="dark:prose-invert mx-auto max-w-xl">
            <a href="/">
              <Logo className="mx-auto size-24 select-none" />
            </a>
            <ul className="mt-12 flex list-none flex-col items-start gap-y-4 pl-0">
              {/* Order link is web checkout: hidden in the iOS shell (App Store 3.1.1). */}
              {LINKS.filter((link) => !(isIosNative() && link.href.startsWith('/order'))).map(
                (link) => (
                  <li
                    key={link.text}
                    className="w-full transform rounded bg-zinc-50 text-center font-semibold text-sm ring-1 ring-zinc-200 duration-100 ease-in-out hover:scale-102 sm:text-base sm:hover:scale-105 dark:bg-white/10 dark:ring-white/20"
                  >
                    <a
                      href={link.href}
                      target={link.target}
                      rel={link.target === '_blank' ? 'noreferrer' : undefined}
                      className="block w-full p-5 text-zinc-900 no-underline hover:text-zinc-800 dark:text-white dark:hover:text-zinc-100"
                    >
                      {link.text}
                    </a>
                  </li>
                ),
              )}
            </ul>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

// Main component
function LinksPage() {
  return <Links />;
}
